import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAdapter } from "../../../auth/axiosAdapter";
import { zumosApiConstants } from "../../../constants/ZumosConstants";

export const deleteOrderItem = createAsyncThunk('order/deleteOrderItem', (data) => {
  const orderId = data.orderId;
  const orderItemId = data.orderItemId;
  console.log("orderSlice::deleteOrderItem:: " + JSON.stringify(data))
  return axiosAdapter().delete(`${zumosApiConstants.ORDER_RESOURCE}/${orderId}/item/${orderItemId}`, data)
    .then((response) => response.data)
})


export const deleteOrderItemFullfilled = (state, action) => {
  state.orders = state.orders.map((order) => {
    if (order._id === action.payload._id) {
      return action.payload;
    }
    return order;
  });
  state.loading = false;
  state.error = ''
};
export const deleteOrderItemPending = (state) => {
  state.loading = true;
};
export const deleteOrderItemRejected = (state, action) => {
  state.loading = false;
  state.error = action.error.message
}